;(function($) {
    $('.product .quantity input[type="number"]').niceNumber({
        autoSize: false
    });
})(jQuery);